import {
  LoadingContainer,
  Panels,
  Bar,
  Breadcrumb,
  ModelViewer,
} from 'peach/components'
import { getName } from 'peach/helpers'
import { useParams, useRouteMatch } from 'peach/router'

import { Page } from 'core/components'
import { useSupercaseGet } from 'core/types'

const Supercase = () => {
  const { url } = useRouteMatch()
  const { supercaseId } = useParams<{ supercaseId?: string }>()

  const { data: supercase, isLoading } = useSupercaseGet({
    supercaseId,
  })

  const title = getName(supercase) || supercase?.name || 'Supercase'

  return (
    <Panels header={<Bar title={title} />}>
      <LoadingContainer loading={isLoading}>
        <Breadcrumb title={title} to={url} />
        <Page variant='full'>
          <ModelViewer
            bare={undefined}
            compact={undefined}
            json={supercase}
            note={undefined}
            page={undefined}
            title={title}
          />
        </Page>
      </LoadingContainer>
    </Panels>
  )
}

export default Supercase
